// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ModalPresentationPropsDefault from "@insite/mobius/Modal/presentationProps";
import { getProp } from "@insite/mobius/utilities";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { xBaseTheme } from "@steiner/XDL/types";
import { color, styledScrollbar, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

export default {
    sizeVariants: {
        small: 420,
        medium: 800,
        large: 1110,
    },
    defaultProps: {
        ...ModalPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            headlineTypography: css`
                margin-bottom: 0;
                letter-spacing: 0;
                line-height: 20px;
            `,
            modalTitle: css`
                position: relative;
                padding: 14px 16px;
                border-bottom: 0;
                &:after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    width: calc(100% - 32px);
                    height: 1px;
                    background-color: ${color("common.border")};
                    margin: 0 auto;
                }
            `,
            modalContent: css`
                ${styledScrollbar()}
                padding: 16px;
            `,
            modalBody: css`
                border-radius: 0;
                background-color: ${color("common.white")};
                border: 1px solid ${color("common.border")};
                ${xScreen("lt", "md")} {
                    max-width: 90%;
                    height: auto;
                    max-height: calc(100% - 30px);
                    margin: 15px;
                }
                ${xScreen("gt", "md")} {
                    height: auto;
                    max-height: calc(100% - 50px);
                }
            `,
        },
        headlineTypographyProps: {
            size: 18,
            weight: "bold",
            fontFamily: fontConfig.bodyFontFamily,
        },
        closeButtonProps: {
            mergeCss: true,
            shape: "rounded",
            buttonType: "solid",
            color: "transparent",
            css: css`
                width: 24px;
                height: 24px;
                padding: 0;
                min-height: initial;
                border-radius: 50%;
                margin: 0;
                border: none;

                & > ${IconWrapper} {
                    top: 0;
                    color: ${color("common.ui5")};
                }

                &:not(:disabled):hover {
                    background-color: transparent;
                    & > ${IconWrapper} {
                        color: ${color("common.ui9")};
                    }
                }

                &:not(:disabled):focus {
                    background-color: transparent;
                    & > ${IconWrapper} {
                        color: ${color("common.ui10")};
                    }
                }
            `,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: "X",
            size: 20,
            css: css`
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            `,
        },
    },
} as xBaseTheme["modal"];
